export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.10-1241.11",
  commitId: "4ed0f7f52eff23e963d9f8ba554d2f0b4c97a313",
  commitTime: "2026-08-10T12:41:11.000Z",
});
